import config from '@/config';

export function init() {
  /*
	window.gapi.load('auth2', () => {
		window.gapi.auth2.init({
			client_id: config.social.googleAppId,
			scope: 'profile email'
		});
	});
  */
}

export function login() {
	return new Promise((resolve, reject) => {
		window.gapi.auth2.getAuthInstance().signIn().then(function(user) {
			const authResponse = user.getAuthResponse(true);

			let info = {
				provider: 'accounts.google.com',
				token: authResponse.id_token,
				accessToken: authResponse.access_token,
				expiration: authResponse.expires_at
			}

			resolve(info);
		});
	});
}



// WEBPACK FOOTER //
// ./src/libs/providers/google.js